(function() {
  var navbar     = document.getElementById('NavbarWrapper');
  var toggle     = document.getElementById('NavbarMobileToggle');
  var mobileMenu = document.getElementById('NavbarMobileMenu');
  var closeBtn   = document.getElementById('NavbarMobileClose');

  if (!navbar) return;

  /* Fija la altura exacta del promo bar para que la transición CSS sea suave */
  var promoBar = document.querySelector('.navbar__promo-bar');
  if (promoBar) {
    promoBar.style.height = promoBar.scrollHeight + 'px';
  }

  /* Scroll: añade sombra + colapsa promo bar */
  var ticking = false;
  window.addEventListener('scroll', function() {
    if (!ticking) {
      requestAnimationFrame(function() {
        navbar.classList.toggle('scrolled', window.scrollY > 40);
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });

  // Mobile menu
  function openMenu() {
    mobileMenu.classList.add('open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    mobileMenu.classList.remove('open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  if (toggle) toggle.addEventListener('click', openMenu);
  if (closeBtn) closeBtn.addEventListener('click', closeMenu);
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeMenu();
  });

  /* Account dropdown */
  var accountToggle   = document.getElementById('AccountToggle');
  var accountDropdown = document.getElementById('AccountDropdown');

  if (accountToggle && accountDropdown) {
    accountToggle.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var isOpen = accountDropdown.classList.toggle('open');
      accountToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      accountDropdown.setAttribute('aria-hidden', isOpen ? 'false' : 'true');
    });

    document.addEventListener('click', function(e) {
      if (!accountDropdown.contains(e.target) && e.target !== accountToggle) {
        accountDropdown.classList.remove('open');
        accountToggle.setAttribute('aria-expanded', 'false');
        accountDropdown.setAttribute('aria-hidden', 'true');
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && accountDropdown.classList.contains('open')) {
        accountDropdown.classList.remove('open');
        accountToggle.setAttribute('aria-expanded', 'false');
        accountDropdown.setAttribute('aria-hidden', 'true');
        accountToggle.focus();
      }
    });
  }
})();
